<!-- eslint-disable import/no-cycle -->
<template>
  <section>
    <b-card>
      <h1>Statistiques sur les agences de location de véhicules sans opérateur</h1>
      <div
        v-if="true"
        class="mt-2"
      >
        <h3>Filtres de recherche</h3>
        <StatisticsFilters
          v-model="filtersForm"
          :active-filters="activeFilters"
          :is-loading="isLoadingTableData"
          @submit="getStatistics"
        />

      </div>
    </b-card>

    <b-row class="match-height">
      <!-- <b-col lg="6">
        <StatsEtablissementParService />
      </b-col> -->

      <!-- <b-col
        v-if="statsData.statsFichesMensuellesHotels && statsData.statsFichesMensuellesHotels.statsEtabParClassement"
        lg="12"
      >
        <NombreEtablissementParClassement
          :statsDatas="statsData.statsFichesMensuellesHotels.statsEtabParClassement"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col> -->
      <!-- <b-col lg="12">
        <NombreTotalNuiteeParLocalisation
          :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col lg="12">
        <NombreMoyenNuiteeParLocalisation
          :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col> -->
      <b-col lg="12">
        <NombreVehiculesDisponibleALaLocation
          :table-datas="statsData.ficheMensuellePerLocation.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col lg="12">
        <NombreVehiculesEffectivementLouesParJour
          :table-datas="statsData.ficheMensuellePerLocation.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>

    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BDropdown,
  BDropdownItem,
  BCardBody,
  BCardText,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { $themeColors } from '@themeConfig'
import utilsService from '@/services/utils/utils.service'
import StatisticsFilters from '@/components/StatisticsFilters.vue'

// store modules and vuex utilities
// eslint-disable-next-line import/no-cycle
import etablissementsStroreModule from '@/store/etablissements'
// eslint-disable-next-line import/no-cycle
import paramsStoreModule from '@/store/params'
// eslint-disable-next-line import/no-cycle
import statisticsStoreModule from '@/store/statistics'
// eslint-disable-next-line import/no-cycle
import formulaireStoreModule from '@/store/formulaire'
import { buildFiltersForRequest } from '@/helpers/http-utils'

// eslint-disable-next-line import/no-cycle
import {
  registerStoreModule,
  unregisterStoreModule,
} from '@/helpers/vuex-utils'
import { mapActions, mapState } from 'vuex'
import NombreVehiculesEffectivementLouesParJour from './NombreVehiculesEffectivementLouesParJour.vue'
import NombreVehiculesDisponibleALaLocation from './NombreVehiculesDisponibleALaLocation.vue'

const activeFilters = [
  'periode',
  // 'trancheAge',
  // 'sexe',
  // 'lieuResidence',
  // 'categorieSocioProfessionnelle',
  // 'modeTransportInterieurBenin',
]

const statsData = {
  clientHotel: {
    tableDatas: {
      departements: [],
      communes: [],
      arrondissements: [],
      villages: [],
    },
  },
  ficheMensuellePerLocation: {
    tableDatas: {
      departements: [],
      communes: [],
      arrondissements: [],
      villages: [],
    },
  },
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BCardText,
    StatisticsFilters,
    BButton,
    BSpinner,
    NombreVehiculesDisponibleALaLocation,
    NombreVehiculesEffectivementLouesParJour,
  },
  setup() {
    const requiredStoreModules = [
      { path: 'etablissements', module: etablissementsStroreModule },
      { path: 'params', module: paramsStoreModule },
      { path: 'statistics', module: statisticsStoreModule },
      { path: 'formulaire', module: formulaireStoreModule },

    ]

    // Register module
    registerStoreModule(requiredStoreModules)

    return { requiredStoreModules }
  },
  data() {
    return {
      isLoadingTableData: false,

      isLoading: false,
      activeFilters,
      filtersForm: {},

      statsData,

    }
  },
  computed: {
    etablissementId() {
      return utilsService.etablissementId
    },
  },
  beforeDestroy() {
    unregisterStoreModule(this.requiredStoreModules)
  },
  async mounted() {
    await this.getStatistics()
  },
  methods: {
    ...mapActions('statistics', {
      action_getStatisticsAgencesVoyageToursOperators:
        'getStatisticsAgencesVoyageToursOperators',
      action_getStatsEtablissementsHebergement: 'getStatsEtablissementsHebergement',
      action_getStatsEtablissementsLocationSansOperateurTransport: 'getStatsEtablissementsLocationSansOperateurTransport',
    }),
    ...mapActions('formulaire', {
      fetchFormulaires: 'fetchFormulaires',
      exportFormulaires: 'exportFormulaires',
    }),
    ...mapActions('etablissements', {
      action_getListTypesEtablissement: 'getListTypesEtablissement',
    }),
    onPaginationChange(val) {
      console.log('paginationChange', val)
      this.paginationData = { ...this.paginationData, ...val }
    },
    localFilter() {
      const query = this.localSearchQuery.toLowerCase()
      this.filteredTableDatas[this.selectedTypeLocalisation] = this.tableDatas[
        this.selectedTypeLocalisation
      ].filter(e => {
        if (!query) return true
        return e.name.toLowerCase().includes(query)
      })
      this.filteredTableDatas[this.selectedTypeLocalisation] = this.filteredTableDatas[this.selectedTypeLocalisation].filter(e => true)
    },
    async getStatistics() {
      this.isLoadingTableData = true
      const periodeFilter = () => {
        const { from, to } = this.filtersForm.periode || {}
        if (!from && !to) return { createdAt: '' }
        const result = !to ? `${from},${from}` : `${from},${to}`
        return { createdAt: result }
      }

      const filters = {
        ...periodeFilter(),
      }

      delete filters.periode
      const processedFilters = buildFiltersForRequest(filters)
      const reqOptions = {
        params: {
          filter: processedFilters,
        },
      }
      await this.action_getStatsEtablissementsLocationSansOperateurTransport(reqOptions)
        .then(async res => {
          console.log('action_getStatsEtablissementsLocationSansOperateurTransport', res)
          const {
            ficheMensuellePerLocation,
            etsCountPerLocation,
            etsCountPerType,
            ficheMensuellesPerMoyensDeTransport,
          } = res || {}
          // this.statsData.etsCountPerType = etsCountPerType
          // console.log(
          //   'statsEtabRestauPerLocation :>> ',
          //   statsEtabRestauPerLocation,
          // )

          // const { tableDatas: nombreEtsTransportPerLocation } = this.statsData.nombreEtsTransportPerLocation
          // etsCountPerLocation.forEach(localisationItem => {
          //   const { items, queryId: localisation } = localisationItem
          //   nombreEtsTransportPerLocation[`${localisation}s`] = items
          // })

          const { tableDatas: statsFicheMensuellePerLocation } = this.statsData.ficheMensuellePerLocation
          ficheMensuellePerLocation.forEach(localisationItem => {
            const { items, queryId: localisation } = localisationItem
            statsFicheMensuellePerLocation[`${localisation}s`] = items
          })

          this.statsData.ficheMensuellePerLocation.tableDatas = [...statsFicheMensuellePerLocation]
          // this.statsData.ficheMensuellesPerMoyensDeTransport.tableDatas = [...ficheMensuellesPerMoyensDeTransport]

          this.isLoadingTableData = false

          // console.log('stats', res)
        })
        .catch(error => {
          this.isLoadingTableData = false

          // console.log(error)
        })
    },

  },
  created() {},
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
